export default "__VITE_ASSET__uMwQYC9V__"